var _defs, _path, _g, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPasswordShow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Password_Visible",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-2{fill:none}\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M12 4.5c3.875-.064 8.191 2.533 11.381 6.275a2.7 2.7 0 0 1 0 3.448C20.2 17.961 15.9 20.569 12.013 20.5c-3.91.07-8.208-2.537-11.391-6.278a2.7 2.7 0 0 1 0-3.448C3.808 7.035 8.124 4.437 12 4.5zm.013 1.6h-.025c-3.38-.06-7.33 2.316-10.252 5.746a1.022 1.022 0 0 0 0 1.3c2.917 3.431 6.845 5.814 10.277 5.754 3.406.061 7.335-2.322 10.254-5.749a1.022 1.022 0 0 0 0-1.3C19.341 8.415 15.391 6.04 12.013 6.1z",
    transform: "translate(-0.002 -0.5)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_11",
    fill: "none",
    stroke: "#000",
    strokeWidth: "1.5px",
    transform: "translate(8 8)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.25,
    className: "cls-2"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_138",
    d: "M0 0H24V24H0z",
    className: "cls-2",
    transform: "translate(0)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPasswordShow);
export default __webpack_public_path__ + "static/media/icon-password-show.838bbc69.svg";
export { ForwardRef as ReactComponent };